var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checker-detail-row',[_c('div',{attrs:{"slot":"left"},slot:"left"},[_vm._v("Duration")]),_vm._v(" "),_c('div',{attrs:{"slot":"right"},slot:"right"},[_vm._v(_vm._s(_vm._f("formattedHours")(_vm.duration)))])])}
var staticRenderFns = []

export { render, staticRenderFns }